import styled from "styled-components";

export const HeaderWrapper = styled.div`
  .headerWrapper {
    padding: 10px;
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    transition: 0.3s ease-in-out;
    z-index: 99;
    background: transparent;

    nav {
      padding: 10px 0;
      border-radius: 12px;
    }
    &.scroll_down {
      transform: translateY(-100%);
      nav {
        background: rgb(255, 255, 255);
        box-shadow: rgba(0, 0, 0, 0.05) 0px 20px 105px;
      }
    }

    &.scroll_up {
      transform: translateY(0);
      nav {
        background: rgb(255, 255, 255);
        box-shadow: rgba(0, 0, 0, 0.05) 0px 20px 105px;
      }
    }
    .headerWrapper_inner {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      > ul {
        background: rgba(17, 17, 17, 0.5);
        backdrop-filter: blur(6.4px);
        border-radius: 25px;
        display: flex;
        flex-wrap: wrap;
        padding: 9px 20px;
        @media (max-width: 1199px) {
          display: none;
        }
        > li {
          width: auto;
          text-align: center;
          padding-bottom: 12px;
          margin-bottom: -12px;
          transition: all 0.4s ease-in-out;
          &:not(:last-child) {
            margin-right: 20px;
            @media (max-width: 1199px) {
              margin-right: 0;
            }
          }

          > a {
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 500;
            font-size: 12px;
            color: rgb(0, 0, 0);
            min-width: 85px;
            padding: 4px 12px;
            background: rgba(255, 255, 255, 1);
            border-radius: 25px;
            opacity: 0.5;
            transition: 0.4s ease-in-out;
            i {
              display: flex;
              align-items: center;
              justify-content: center;
              flex-shrink: 0;
              line-height: 0;
              margin-left: 4.5px;
            }
          }
          .submenuUl {
            position: absolute;
            left: 0px;
            top: 100%;
            background: rgb(255, 255, 255);
            padding: 0px;
            margin: 0px;
            min-width: 200px;
            box-shadow: rgb(136 66 15 / 59%) 4px 10px 40px -8px;
            display: none;
            border-radius: 5px;
            overflow: hidden;
            transition: 0.5s ease-in-out;
            > li {
              > a {
                color: rgb(0, 0, 0);
                font-size: 15px;
                padding: 5px 15px;
                width: 100%;
                text-align: left;
                transition: 0.4s ease-in-out;
                &:hover {
                  background: rgba(17, 17, 17, 0.5);
                  color: rgb(255, 255, 255);
                }
              }
            }
          }
          &:hover {
            a {
              opacity: 1;
            }
            .submenuUl {
              display: block;
            }
          }
          &.active {
            a {
              opacity: 1;
            }
          }
        }
      }

      .header_rht_Wrap {
        display: flex;
        align-items: center;
        gap: 17px;
        .contact_btn {
          min-width: 190px;
          min-height: 43px;
          background: rgb(255, 24, 24);
          border-radius: 25px;
          padding: 10px 15px;
          font-weight: 600;
          font-size: 16px;
          color: rgb(255, 255, 255);
          line-height: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease-in;
          border: 1px solid transparent;
          svg {
            display: none;
            @media (max-width: 599px) {
              display: flex;
            }
          }
          @media (max-width: 1199px) {
            border-radius: 12px;
            min-width: auto;
          }
          @media (max-width: 599px) {
            font-size: 0;
            min-width: auto;
            border-radius: 50%;
            padding: 7px;
            width: 35px;
            height: 35px;
            padding: 3px;
            min-height: auto;
          }
          &:hover {
            color: rgb(0, 0, 0);
            background: rgb(255, 235, 235);
            border-color: rgb(255, 24, 24);
          }
        }
        .menuIconbtn {
          display: none;
          @media (max-width: 1199px) {
            display: flex;
          }
          background: transparent;
          transition: 0.4s ease-in-out;
          &:hover {
            color: rgb(255, 24, 24);
          }
        }
      }
    }
    .headerLogo {
      @media (max-width: 1199px) {
        max-width: 170px;
      }
      @media (max-width: 899px) {
        max-width: 150px;
      }
      @media (max-width: 599px) {
        max-width: 120px;
      }
    }
  }
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100dvh;
    background: rgb(0 0 0 / 84%);
    z-index: 99;
  }
`;
